import type { TFunction } from 'i18next';

import { CopyButton } from '../../atoms/copy-button/copy-button';
import { SubRowTableColumn } from '../sub-row-table/sub-row-table';

type InviteStatusRow = {
  readonly publicId: string;
  readonly serviceUserLink: string;
  readonly status: string;
};

const getInviteStatusColumns = <T extends InviteStatusRow>(t: TFunction): SubRowTableColumn<T>[] => [
  {
    header: t('model.common.status'),
    render: (invite) => t(`model.invite.status.${invite.status}`),
  },
  {
    header: t('model.common.publicId'),
    render: (invite) => invite.publicId,
  },
  {
    header: t('model.common.serviceUserLink'),
    render: (invite) =>
      invite.status === 'pending' && (
        <CopyButton
          copiedLabel={t('common.buttons.copied')}
          copyLabel={t('common.buttons.copyLink')}
          value={invite.serviceUserLink}
        />
      ),
  },
];

export { getInviteStatusColumns };
